/* ------------------------------------------------------------------ wt-ship-note.js (Oct 18 2026): SHIPPING SHOWN BEFORE CHECKOUT
   Shipping (Settings > Shipping, USA): $8.75 under $70, free at $70+. Every cap is $35+, so any 2 caps ship free.
   Jaime, Oct 17 2026: show the shipping cost early so checkout has no surprise (checkout to purchase was 29%).
   a) Product page: one small line under the Shop Pay installments line (falls back to above the add to cart form).
   b) Cart drawer: the "Taxes and shipping calculated at checkout" note now says the real shipping cost.
   c) The cart ladder message ("Add $X more for free shipping") gets "Shipping $8.75 · " in front.
   RULE: if the shipping rate or the $70 line changes in Shopify, change SHIP and FREE_CENTS here. Loaded from layout/theme.liquid right after wt-cart-drawer.js. */
(function () {
  'use strict';
  var SHIP = '$8.75';
  var FREE_CENTS = 7000;
  var PDP_TEXT = 'Shipping $8.75 · Free shipping on 2 caps ($70+)';
  var NOTE_PAID = 'Shipping $8.75, free at $70. Taxes calculated at checkout.';
  var NOTE_FREE = 'Free shipping on this order. Taxes calculated at checkout.';

  function pdpNote() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('[data-wt-ship-note]')) return;
    var html = '<p data-wt-ship-note class="wt-ship-note" style="margin:8px 0 0;font-size:13px;line-height:1.4;letter-spacing:.02em;opacity:.8">' + PDP_TEXT + '</p>';
    var terms = document.querySelector('shopify-payment-terms');
    if (terms) {
      var host = terms.closest('form') || terms;
      host.insertAdjacentHTML('afterend', html);
      return;
    }
    var form = document.querySelector('main form[action*="/cart/add"], form[action*="/cart/add"]');
    if (form) form.insertAdjacentHTML('beforebegin', html);
  }

  var total = null;
  function paintNote() {
    var d = document.getElementById('CartDrawer');
    if (!d || total === null) return;
    var n = d.querySelector('.tax-note');
    if (!n) return;
    var txt = total >= FREE_CENTS ? NOTE_FREE : NOTE_PAID;
    if (n.textContent.trim() !== txt) n.textContent = txt;
    /* Ladder message from wt-cart-drawer.js: "Add $X more for free shipping" gets "Shipping $8.75 · " in front. */
    var m = d.querySelector('.wt-ladder__msg');
    if (m && total < FREE_CENTS && /^Add /.test(m.textContent.trim()) && !m.querySelector('[data-wt-ship]')) {
      m.insertAdjacentHTML('afterbegin', '<span data-wt-ship>Shipping ' + SHIP + ' · </span>');
    }
  }
  function loadCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; paintNote(); })
      .catch(function () {});
  }

  function init() {
    pdpNote();
    var d = document.getElementById('CartDrawer');
    if (d) {
      document.addEventListener('cart:updated', function (e) {
        var c = e.detail && e.detail.cart;
        if (c && typeof c.total_price === 'number') { total = c.total_price; paintNote(); } else loadCart();
      });
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(loadCart, 80); }).observe(d, { childList: true, subtree: true });
      loadCart();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
